// extracted by mini-css-extract-plugin
module.exports = {"testimonialCards":"Testimonials-module--testimonialCards--3g3f4","testimonialQuote":"Testimonials-module--testimonialQuote--2SWr8"};